import { Component, Input } from '@angular/core';

export enum IrisButtonContainerMobileLayouts {
  FULLWIDTH = 'full-width',
  SIDEBYSIDE = 'side-by-side'
}

export enum IrisButtonContainerAlignments {
  START = 'start',
  END = 'end',
  VERTICAL_START = 'vertical-start',
  VERTICAL_END = 'vertical-end'
}

export enum IrisButtonContainerDesktopLayouts {
  FIT_CONTENT = 'fit-content',
  FULLWIDTH = 'full-width',
}

@Component({
  selector: 'iris-button-container',
  host: {
    class: 'iris-button-container',
    '[class.--side-by-side]': 'mobileLayout === mobileLayoutOptions.SIDEBYSIDE',
    '[class.--start]': 'alignment === alignmentOptions.START',
    '[class.--end]': 'alignment === alignmentOptions.END',
    '[class.--vertical-start]': 'alignment === alignmentOptions.VERTICAL_START',
    '[class.--vertical-end]': 'alignment === alignmentOptions.VERTICAL_END',
    '[class.--full-width-desktop]': 'desktopLayout === desktopLayoutOptions.FULLWIDTH'
  },
  templateUrl: './button-container.component.html',
  styleUrls: ['./button-container.component.scss']
})

export class IrisButtonContainerComponent {
  private alignmentOptions = IrisButtonContainerAlignments;
  private mobileLayoutOptions = IrisButtonContainerMobileLayouts;
  private desktopLayoutOptions = IrisButtonContainerDesktopLayouts;
  @Input() alignment: IrisButtonContainerAlignments = this.alignmentOptions.START;
  @Input() mobileLayout: IrisButtonContainerMobileLayouts = this.mobileLayoutOptions.FULLWIDTH;
  @Input() desktopLayout: IrisButtonContainerDesktopLayouts = this.desktopLayoutOptions.FIT_CONTENT;
}
